// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"45b12e96","754":"f775fbd3"}[chunkId] + ".chunk.js");